import {ProgressBar} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import MediaSelectBox from "./MediaSelectBox"
import MediaInput from "./MediaInput";
import {getData} from "./api/api";
const ProgressBarUpload = (props) => {
    console.log('props.errorMessage is ==', props)
    const [mediaExtraFieldData, setMediaExtraFieldData] = useState([]);
    const [approvalData, setApprovalData] = useState([]);
    const [approval, setApproval] = useState([]);
    const [language, setLanguage] = useState([]);
    const [product, setProduct] = useState([]);
    const [fileRename, setFileRename] = useState('')
    const noImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAZAAAAGQCAYAAACAvzbMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAACkVJREFUeNrs3W9PGkkAwGFSBDnJwh629+LeaOL3/0gm+vJyd01bU1Pt6d1MuySEU4FlZ/8+T0L6olFwXPbHwDj7bgQAJbwzBAAICAACAoCAACAgACAgAAgIAAICgIAAICAAICAACAgAAgKAgAAgIAAgIAAICAACAoCAACAgACAgAAgIAAICgIAAICAAICAACAgAAgKAgAAgIAAgIAAICAACAoCAACAgACAgAAgIAAICgIAAgIAAICAACAgAAgKAgACAgAAgIAAICAACAoCAAICAACAgAAgIAAICgIAAgIAAICAACAgAAgKAgACAgAAgIAAICAACAoCAAICAACAgAAgIAAICgIAAgIAAICAACAgAAgKAgACAgAAgIAAICAACAgACAoCAACAgAAgIAAICAAICgIAAICAACAgAAgIAAgKAgAAgIAAICAACAgACAoCAACAgAAgIAAICAAICgIAAICAACAgAAgIAAgKAgAAgIAAICAACAgACAoCAACAgAAgIAAgIAAICgIAA0HYnhuA4VxeXp+GfqZGAznm6vr25NwwC0qQYj8wwQOc8hpuAHMFbWAAICAACAoCAACAgACAgAAgIAAICgIAAICAAICAACAgAAgKAgAAgIAAgIAAICAACAoCAACAgAPCWE0PQWk/FDfh5rvKCV0DY0/317c2dYYDR6Ori8n34Z2ok2kXRARAQAAQEAAGhpLEhAASEMixwAAQEAAEBAAEBQEAAEBAABAQAAQEAAQFAQAAQEAA6xHYZ0DNXF5dxH7VZuJ2Ofu6pNtn47/WFyh7C7dv17c13I4aAgHCchX/mW8HYNi5u8eJMWfiaGJP7cPsaYvJsFBEQGFY4YjDyHeF4KyhZDE/4Pp9CRL4ZUQQEhjPryCv4VvHz0FX4fnE28sVshH0PGqCb8cgrisemGKTz8L2dGxAQ6Gk8suJkn0J8K+zcKCMg0L94xBVWWeK7mYT7WRptBAT6E4/4nM1rurv4wfqpUUdAoB8WNT9vc0OOgED3Zx9xye1ZzXc7LlZ6gYBAh80aul8BQUCg45o6kU8t60VAoKOKE/ikwYcw81tAQKCbJg3f/9ivAAGBbmp62yHLeREQ8FwFByUAAgKAgAApPDZ8/65ciICQlr2Tkvln4PePgNDzeMS/FTgvrpBHha5vb9bXMh/qDAgBoefW23+LSBoPDd3vUwiYt7AQEJLNPuI2G+ON40pEqve1ofu9N/QICKniEY+j7IVjS0QqVMwC6n4r6bnBcCEgDMB89PJWF+uIOM6q87nuWU8I17NhR0BINfuY7zjGRKTaWchdTXf3PdzfnVFHQEgl2+M4mohIpRGJJ/XUb2XFWcdHo42AkGr2Md4x+xCRdOLJPdXKqBiPv4ulwyAgJJt9HOJHRAxbJbOQHyf5BDORpyIelu0iICSbfcQYlLlC3iR8bW4Eq4lIuP01qu4zkW/h9qd4ICCktjzia89EpNKQxID8MSr/9xqPxazjoxVXHOLEEFBi9hH3u5oe+W1iROLJ75MRrSQi8a2nT2FMY0ziljK/7Pgdrf+m5N6MAwGhTllF3ydG5N9wAvtsSCsNydfitl7osPk8fxYMBISmZh9nFcw+Ns3D94x/b2C7jHRBsZqKJHwGQlOzj015ESZAQOjp7OO1LUtEBAQEXo3Hu0SzDxEBAaHn5jUdLws7+IKA0K/Zx7zGY9I28CAg9MSi5mNFREBA6MHsI35oftbQsdmpiMSZWrhljhoEBH7KGj4+Vx3awTe+zZeFx/versMICEOffZw2NPvYNB51YBv4ra3tpyNb1yMgmH20QheuJbJ9Ya34mH/zOQ4CwlBnH9MWPaTWRuSNmdr6c5xTRxQCwpC0cbv1GJFVCx/XYsdz7NwfSCIgDGX2EU9245Y+vGmbriVSjNU+b1PlVmghIAxB2090rbggVfF22uKQcXUhLQSEPs8+shbPPtoWkTLbu5xZ5ouA0Md41LllSVURyRoaq/ERMzXLfBEQemfewWMia+gD6uWRX2+ZLwJCb2Yfx7yiblqt28AXy3JnFT3/4kxk5ghEQOiyrq8QqjMiecXPwZVlvggIXZ599OEElqd+NZ/wqozxsS8djQgIXfNrj36WPNXnCjVclXFumS8CQpdmH23bsqSKYzrVNvBZDc+ZuLLsgxVaCAhdkPX0uK40IsX3qmuJ83rfr7HDEwGhrbOPWc9mHykjUvfnE/Fxf7DMFwGhrZYDOL7zY98OajC0lvkiILRy9tHmDROrfiV/7F99Lxt+jlrmi4DQmngcugngYCPSor3BLPNFQGiF+QB/9wdHpIV7g1nmi4DQ+OxjPtAfP0bkkBPwooXPEct8ERAakw389z7b51X8G5epbdNsygotBITaZh/jAc8+tl/F74pI2/8+RkQQEGqffbAjIsWKp2lHnr+ut46AkHz2EV+pOtH8PyLzrXFKvd9ViudwLiIICClZAvrKuGydfFPttptaboUWdTsxBIOYffRtw8QUJ9/478Oo258RnRU/x5fr25tnv1bMQKjCwhDsjki4rXrwnIizKddbR0CoZPYRTyhW6uxn0qOfwwotBISjWXk13BiKCAJC6dlHVz8Qprrn9wcrtBAQDo1H15ajkk6+vVwZBIS3zP1+2bC0zBcBYd/Zh1ecbIvLfFdWaCEgvGXhd8sr4tUNLfNFQHhx9hE/NPehKW9xvXUEhBf54Jx9jIuZyKmhQEBYsz0Nhzz/7eaLgACl5cW130FAgINllvkiIEBZrreOgAClrffQsgUOAgKUiohlvggIUPrcEGciM0OBgABlzg8ry3wREKAs11vnRf7oDNiH661jBgKUj8jIRowICFCSFVoICFDaeiNGEREQgFLnDtdbdxAAlGYjRgEBKM1GjANlGW//3Ifbg2GgbvHiVNe3N449AaGrwhP43igAdfAWFgACAoCAACAgAAgIAAgIAAICgIAAICAACAgACAgAAgJAU2ym2F7Tq4vL3w0DYAYCgIAAgIAAICAACAgAAgKAgACAgAAgIAAICAACAoCAAICAACAgAAgIAAICgIAAgIAAICAACAgAXXRiCI72GG53hgE658kQAEADvIUFgIAAICAACAgAAgIAAgKAgAAgIAAICAACAgACAoCAACAgAAgIAAICAAICgIAAICAACAgAAgIAAgKAgAAgIAAICAACAgACAoCAACAgAAgIAAICAAICgIAAICAACAgAAgIAAgKAgAAgIAAICAAICAACAoCAACAgAAgIAAgIAAICgIAAICAACAgACAgAAgKAgAAgIAAICAAICAACAoCAACAgAAgIAAgIAAICgIAAICAACAgACAgAAgKAgAAgIAAICAAICAACAoCAACAgAAiIIQBAQAAQEAAEBAABAQABAUBAABAQAAQEAAEBAAEBQEAAEBAABAQAAQEAAQFAQAAQEAAEBAABAQABAUBAABAQAAQEAAEBAAEBQEAAEBAABAQAAQEAAQFAQAAQEAAEBAABAQABAUBAABAQAAQEAAQEgJL+E2AAvv8YFBUVTjoAAAAASUVORK5CYII=\n';
    const aspectRatio = [
        {"label":'Select aspect ratio',"value":""},
        {"label":'1:1',"value":'1:1'},
        {"label":'3:4',"value":'3:4'},
        {"label":'4:3',"value":'4:3'},
        {"label":'2:3',"value":'2:3'},
        {"label":'3:2',"value":'3:2'},
        {"label":'16:9',"value":'16:9'},
        {"label":'9:16',"value":'9:16'},
        {"label":'Outdoor Fascia',"value":'outdoor_fascia'},
    ]
    const allowedTypes = ['image/png', 'image/jpeg', 'image/gif']
    useEffect(() => {
        getData(`materials/language_categories`,setMediaExtraFieldData)
        getData(`materials/get_approval_list`,setApprovalData)
    }, [])

    useEffect(() => {
        if(props.data.length > 0) {
            props.data.map((fileData,index) => {
                const previewImage = document.getElementById('previewImage-'+fileData.name);
                const file = props.data[index].file;
                if (file) {
                    if(allowedTypes.includes(file.type)){
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = function (e) {
                            previewImage.src = e.target.result;
                        }
                    }
                }
            })
        }
    }, [props.data])

    useEffect(() => {
        let language = mediaExtraFieldData.languages;
        if(mediaExtraFieldData.languages !== undefined){
            let lanData = mediaExtraFieldData.languages.map((lan) => {
                return {'label':lan.name,value:lan.id}
            })
            lanData.unshift({'label':'Select language',value:""})
            setLanguage(lanData)
        }
        if(mediaExtraFieldData.product_categories !== undefined){
            let product = mediaExtraFieldData.product_categories.map((product) => {
                return {'label':product.name,value:product.id}
            })
            product.unshift({'label':'Select product',value:""})
            setProduct(product)
        }
    }, [mediaExtraFieldData])

    useEffect(() => {
        if(approvalData.length > 0){
            let appData = approvalData.map((data) => {
                return {'label':data.name,'value':data.id}
            })
            appData.unshift({'label':'Select approver',value:""})
            setApproval(appData)
        }
    }, [approvalData])
    return (
        /*  <ul>
              {props.data.map((file, index) => (
                  <>
                      <div>
                          <li key={index} id={'progressbar-' + file.name} className="li-progress">
                              <div>{file.name} <span id={'error-' + file.name} className="hide red">(File name already exists. Please choose to save as a copy or replace existing file)</span>
                              </div>
                              < ProgressBar striped variant="success" id={file.name} now={0}/>
                          </li>
                          <span className="duplicate-btn">
                            <span id={'replace-' + file.name} className="btn action-upload-btn hide" title="Replace"
                                  onClick={() => {
                                      props.duplicateImage('replace', file.name)
                                  }}>
                                <i className="fas fa-exchange-alt" aria-hidden="true"></i>
                            </span>
                            <span id={'copy-' + file.name} className="btn action-upload-btn hide" title="Copy"
                                  onClick={() => {
                                      props.duplicateImage('copy', file.name)
                                  }}>
                                <i className="fa fa-clone fa-1x" aria-hidden="true"></i>
                            </span>
                          </span>
                      </div>
                  </>
              ))}
          </ul>*/
        <div className="App">
            {props.data.length > 0 &&
                <table className="mediaUploadTable">
                    <tr>
                        <th></th>
                        <th>Name<sup>*</sup></th>
                        <th>Aspect Ratio<sup>*</sup></th>
                        <th>Product Category<sup>*</sup></th>
                        <th>Sub-Product Type</th>
                        <th>Language<sup>*</sup></th>
                        <th>Expiry Date<sup>*</sup></th>
                        <th>Control Group</th>
                        <th>Approver<sup>*</sup></th>
                        {/*<th>Progress</th>*/}
                    </tr>
                    <tbody>
                    {props.data.map((file, index) => {
                        return (
                            <tr key={file.name}>
                                <td>
                                    <img src={noImage} className="uploadMediaPreview"
                                         id={'previewImage-' + file.name} alt="Preview"/>
                                    < ProgressBar striped variant="success" id={file.name} now={0}/>
                                </td>
                                <td>
                                    {/*<input placeholder="Name" className="upload_media_field"
                                       id={'rename-' + file.name} type="text" />*/}
                                    <MediaInput  id={'rename-' + file.name} placeholder="Name" value={file.name}/>
                                </td>

                                <td>
                                    <MediaSelectBox calss={'media_select_width'} id={'aspectRatio-' + file.name} menuItem={aspectRatio}/>
                                </td>
                                <td>
                                    <MediaSelectBox calss={'media_select_width'} id={'productCategory-' + file.name}
                                                    defaultValue={""} menuItem={product}/>
                                </td>
                                <td><input placeholder="Sub product type" className="upload_media_field"
                                           id={'subProductType-' + file.name} type="text"/>
                                </td>
                                <td>
                                    <MediaSelectBox calss={'media_select_width'} id={'language-' + file.name} defaultValue={""}
                                                    menuItem={language}/>
                                </td>
                                <td><input className="upload_media_field" id={'expireDate-' + file.name} type="date"/></td>
                                <td><input placeholder="Control Group" className="upload_media_field"
                                           id={'control_group-' + file.name} type="text"/></td>
                                <td>
                                    <MediaSelectBox calss={'media_select_width'} id={'approval-' + file.name} defaultValue={""}
                                                    menuItem={approval}/>
                                </td>
                                <td>
                                    <div>
                                        <div key={index} id={'progressbar-' + file.name} className="li-progress">
                                            <div><span id={'error-' + file.name} className="hide red">(File name already exists. Please choose to save as a copy or replace existing file)</span>
                                            </div>
                                            {/*< ProgressBar striped variant="success" id={file.name} now={0}/>*/}
                                        </div>
                                        <span className="duplicate-btn">
                                   <span id={'replace-' + file.name} className="btn action-upload-btn hide"
                                         title="Replace"
                                         onClick={() => {
                                             props.duplicateImage('replace', file.name)
                                         }}>
                                       <i className="fas fa-exchange-alt" aria-hidden="true"></i>
                                   </span>
                                   <span id={'copy-' + file.name} className="btn action-upload-btn hide" title="Copy"
                                         onClick={() => {
                                             props.duplicateImage('copy', file.name)
                                         }}>
                                       <i className="fa fa-clone fa-1x" aria-hidden="true"></i>
                                   </span>
                                 </span>
                                    </div>
                                </td>
                            </tr>
                        )
                    })}
                    </tbody>
                </table>
            }
        </div>
    )
}
export default ProgressBarUpload;